import React, { useState } from 'react';
import CoreMonetizationUpsellPopup from './CoreMonetizationUpsellPopup';

export interface CoreMonetizationUpsellPopupReturn {
  coreUpsellPopup: React.ReactNode;
  showCoreUpsellPopup: () => void;
}

export function useCoreMonetizationUpsellPopup(): CoreMonetizationUpsellPopupReturn {
  const [showPopup, setShowPopup] = useState(false);
  const requestClose = () => setShowPopup(false);
  
  const coreUpsellPopup = showPopup ? (
    <CoreMonetizationUpsellPopup requestClose={requestClose} />
  ) : null;

  return {
    showCoreUpsellPopup: () => setShowPopup(true),
    coreUpsellPopup,
  };
}
